import React, {useState} from 'react';
import { useNavigate } from "react-router-dom";
import * as yup from 'yup';
import {useFormik} from 'formik';
import {UnPwLogin, useAuthDispatch} from '../../context';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Visibility from '@mui/icons-material/Visibility';

export default function UnPwLoginForm () {

	const dispatch = useAuthDispatch();
	const navigate = useNavigate();

	const [showPassword, setShowPassword] = useState(false);

	const handleClickShowPassword = () => {
		setShowPassword(!showPassword);
	}

	const formSubmit = async (formValue) => {
		try {
			const response = await UnPwLogin(dispatch, formValue);
			if (response.status === 'Success') {
				navigate('/pcd');
			}
		} catch (e) {
			console.error(e)
		}

	}

	const UnPwForm = useFormik({
		initialValues: {
			username: '',
			password: ''
		},
		validationSchema: yup.object({
			username: yup.string().required('Username is required'),
			password: yup.string().required('Password is required')
		}),
		onSubmit: async (values) => {
			formSubmit(values)
		},
	});

	return (
		<Box component="form" onSubmit={(e) => {
			e.preventDefault();
			UnPwForm.handleSubmit();
		}} sx={{ mt: 1 }}>
			<TextField
				margin="normal"
				required
				fullWidth
				id="username"
				label="Username"
				name="username"
				autoComplete="username"
				value={UnPwForm.values.username}
				onChange={UnPwForm.handleChange}
			/>
			<TextField
				margin="normal"
				required
				fullWidth
				name="password"
				label="Password"
				type={showPassword ? 'text' : 'password'}
				id="password"
				autoComplete="current-password"
				value={UnPwForm.values.password}
				onChange={UnPwForm.handleChange}
				InputProps={{
					endAdornment: <InputAdornment position="end">
						<IconButton
							aria-label="toggle password visibility"
							onClick={handleClickShowPassword}
						>
							{showPassword ? <VisibilityOff /> : <Visibility />}
						</IconButton>
					</InputAdornment>
				}}
			/>
			<Button
				type="submit"
				fullWidth
				variant="contained"
				sx={{ mt: 3, mb: 2 }}
			>
				Sign In
			</Button>
		</Box>
	);
}

